<template>
  <header
    class="flex justify-between items-center p-4 bg-nucleus-white dark:bg-nucleus-darkBlue"
  >
    <div class="flex items-center">
      <router-link :to="to">
        <button class="block mr-4" :aria-label="'Go Back to' + name">
          <span
            class="block align-middle text-3xl text-nucleus-grey dark:text-white icon-arrow-left"
            :title="$t('titles.goBack')"
          ></span>
        </button>
      </router-link>
      <div class="font-bold text-nucleus-text capitalize">{{ name }}</div>
    </div>
    <!-- <div>
      <DarkToggle></DarkToggle>
    </div> -->
    <button
      v-if="!noMenu"
      class="block"
      :aria-label="'Toggle menu'"
      @click="toggleMenu()"
    >
      <span
        class="icon-kebab block align-middle text-3xl text-nucleus-grey dark:text-white"
        :title="$t('titles.menu')"
      ></span>
    </button>
    <div
      v-if="menu"
      v-click-away="toggleMenu"
      class="fixed top-20 left-0 z-20 p-2 w-full"
    >
      <div class="bg-nucleus-white shadow-lg">
        <div
          v-if="canEdit"
          class="p-4 cursor-pointer hover:bg-gray-100"
          @click="edit()"
        >
          {{ $t("global.defaults.editItem", { item: text }) }}
        </div>
        <div
          v-if="canAddUsage"
          class="p-4 cursor-pointer hover:bg-gray-100"
          @click="addUsage()"
        >
          {{ $t("pages.tenancy.addCredits") }}
        </div>
        <div
          v-if="canDeactivate"
          class="p-4 cursor-pointer hover:bg-gray-100"
          @click="deactivate()"
        >
          <span v-if="state === 'ACTIVE'">
            {{ $t("global.defaults.deactivateItem", { item: text }) }}
          </span>
          <span v-else>
            {{ $t("global.defaults.activateItem", { item: text }) }}
          </span>
        </div>
        <div
          v-if="canResend"
          class="p-4 cursor-pointer hover:bg-gray-100"
          @click="resend()"
        >
          {{ $t("pages.tenancy.resendVerification") }}
        </div>
        <div
          v-if="canDelete"
          class="p-4 cursor-pointer hover:bg-gray-100 border-t border-gray-300 text-nucleus-error text-sm"
          @click="deleteCheck()"
        >
          {{ $t("global.defaults.deleteItem", { item: text }) }}
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import DarkToggle from "@/components/global/DarkToggle.vue"; // @ is an alias to /src

@Options({
  props: {
    name: String,
    to: Object || String,
    noMenu: Boolean,
    canDelete: Boolean,
    canEdit: Boolean,
    canDeactivate: Boolean,
    canAddUsage: Boolean,
    canResend: Boolean,
    text: String,
    state: String,
  },
  emits: [
    "deleteCheck",
    "edit",
    "resend",
    "deactivate",
    "activate",
    "addUsage",
  ],
  components: {
    DarkToggle,
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    logo() {
      return "logo_black.svg";
    },
    pageName() {
      return this.$route.name;
    },
  },
  methods: {
    toggleMenu() {
      this.menu = this.menu ? false : true;
    },
    deleteCheck() {
      this.toggleMenu();
      this.$emit("deleteCheck");
    },
    edit() {
      this.toggleMenu();
      this.$emit("edit");
    },
    deactivate() {
      this.toggleMenu();
      if (this.state === "ACTIVE") {
        this.$emit("deactivate");
      } else {
        this.$emit("activate");
      }
    },
    addUsage() {
      this.toggleMenu();
      this.$emit("addUsage");
    },
    resend() {
      this.toggleMenu();
      this.$emit("resend");
    },
  },
})
export default class HeaderMini extends Vue {}
</script>
